module.exports = __webpack_public_path__ + "static/media/cockroach(22).3b900922.PNG";